import {
    // FILE_UPLOAD,
    CREATE_ARCHITECTUREREGULATORS,
    RETRIEVE_ARCHITECTUREREGULATORS,
    RETRIEVESINGLE_ARCHITECTUREREGULATORS,
    UPDATE_ARCHITECTUREREGULATORS,
    DELETE_ARCHITECTUREREGULATORS,
} from "./type";
import ARCRegulators from "../service/arcRegulators";
// export const fileUpload = (data) => async (dispatch) => {
//   try {
//     const res = await ARCRegulators.fileUpload(data);
//     dispatch({
//       type: FILE_UPLOAD,
//       payload: res.data.data,
//     });
//     return Promise.resolve(res.data);
//   } catch (err) {
//     return Promise.reject(err);
//   }
// };
export const create = (data) => async (dispatch) => {
    try {
        const res = await ARCRegulators.create(data);
        dispatch({
            type: CREATE_ARCHITECTUREREGULATORS,
            payload: res.data,
        });
        return Promise.resolve(res.data);
    } catch (err) {
        return Promise.reject(err);
    }
};
export const retrieve = (data) => async (dispatch) => {
    try {
        const res = await ARCRegulators.fetchList(data);
        dispatch({
            type: RETRIEVE_ARCHITECTUREREGULATORS,
            status: '',
            response: {},
            payload: res.data.data,
        });
        return Promise.resolve(res.data.data);
    } catch (err) {
        console.log(err);
        return Promise.reject(err);
    }
};
export const retrieveSingle = (data) => async (dispatch) => {
    try {
        const res = await ARCRegulators.fetchSingle(data);
        // dispatch({
        //     type: RETRIEVESINGLE_ARCHITECTUREREGULATORS,
        //     status: '',
        //     response: {},
        //     payload: res.data.data,
        // });
        return Promise.resolve(res.data.data);
    } catch (err) {
        console.log(err);
        return Promise.reject(err);
    }
};
export const update = (data) => async (dispatch) => {
    try {
        const res = await ARCRegulators.update(data);
        dispatch({
            type: UPDATE_ARCHITECTUREREGULATORS,
            status: '',
            response: {},
            payload: res.data,
        });
        return Promise.resolve(res.data);
    } catch (err) {
        return Promise.reject(err);
    }
};
// export const changeStatus = (data) => async (dispatch) => {
//     try {
//         const res = await ARCRegulators.changeStatus(data);
//         dispatch({
//             type: UPDATE_ARCHITECTUREREGULATORS,
//             status: '',
//             response: {},
//             payload: res.data,
//         });
//         return Promise.resolve(res.data);
//     } catch (err) {
//         return Promise.reject(err);
//     }
// };
export const trash = (data) => async (dispatch) => {
    try {
        const res = await ARCRegulators.trash(data);
        dispatch({
            type: DELETE_ARCHITECTUREREGULATORS,
            status: '',
            response: {},
            payload: res.data,
        });
        return Promise.resolve(res.data);
    } catch (err) {
        return Promise.reject(err);
    }
};